import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {AuthInitState, User} from '@/store/auth/auth.types';
import {AxiosResponse} from 'axios';
import {Toast} from '@/store/toast/toast.types';

const namespaced = true;

export interface HandleInitState {
  response: any,
  refCode: string;
  showRef: boolean;
}

export const handleInitState: HandleInitState = {
  response: {},
  refCode: '',
  showRef: false
};

export const handleState = {
  namespaced,
  state: handleInitState,
  actions: {
    _httpResponse: async (req: ActionContext<AuthInitState, RootState>, payload: AxiosResponse): Promise<void> => {
      let {dispatch, commit} = req;
      console.log('DEBUG: payload', payload);
      const status = payload.status;
      let toastMsg = {} as Toast;
      if (status === 404) {
        toastMsg = {
          message: '404',
          heading: `ผิดพลาด`,
          type: 'warning',
        };
        await dispatch('toast/_Toast', toastMsg, {root: true});
        throw new Error(payload.statusText);
      }
      const {appCode} = payload.data;
      let error = null;
      if (appCode === 50004) {
        toastMsg = {
          message: 'ไม่พบข้อมูลกรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง',
          heading: `ไม่สำเร็จ`,
          type: 'danger',
        };
        error = true;
      } else if (appCode === 50017) {
        toastMsg = {
          message: 'รหัสผิดพลาด กรุณาตรวจสอบอีกครั้ง',
          heading: `ไม่สำเร็จ`,
          type: 'danger',
        };
        error = true;
      } else if (appCode >= 50000) {
        toastMsg = {
          message: 'เกิดข้อผิดพลาดกรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง',
          heading: `ไม่สำเร็จ`,
          type: 'danger',
        };
        error = true;
      }
      // else {
      //   toastMsg = {
      //     message: 'ทำรายการไม่สำเร็จ กรุณาตรวจสอบข้อมูลแล้วลองอีกครั้ง',
      //     heading: `ไม่สำเร็จ`,
      //     type: 'warning',
      //   };
      //   await commit('handle/_errorReferentMutation', `${payload.data.appCode}`, {root: true});
      // }
      console.log('DEBUG: toastMsg', toastMsg);
      if (toastMsg.message) {
        await dispatch('toast/_Toast', toastMsg, {root: true});
      }
      if (error) {
        console.log('DEBUG: _httpResponse error ', payload.data);
        throw new Error(JSON.stringify(payload.data))
      }
    },
    _errorReferent: ({commit}: ActionContext<AuthInitState, RootState>, code: string) => {
      commit('_errorReferentMutation', code);
    },
  },
  mutations: {
    _errorReferentMutation: (state: HandleInitState, payload: string) => {
      state.refCode = payload;
      state.showRef = true;
      setTimeout(() => state.showRef = false, 15000)
    }
  },
};
